
export function GetSection(zoneWidth){
    const barWidth =  (zoneWidth/3 );
    const section = barWidth/96;
    return section;
}